import api from "@/plugins/api/EntryPoint";

export default {
  async getLastIndications(params, callBackFn) {
    console.log("INDICATION HISTORY: " + JSON.stringify(params));
    await api.post("indication/history", params, callBackFn);
  },
};
